import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import cn from 'classnames';
import transition from "../styles/transition";
import { jsx as _jsx } from "react/jsx-runtime";
var ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    isDark = _ref.isDark,
    darkMode = _ref.darkMode,
    backgroundColorProp = _ref.backgroundColor,
    backgroundClassName = _ref.backgroundClassName,
    barColorProp = _ref.barColor,
    barClassName = _ref.barClassName,
    full = _ref.full,
    className = _ref.className,
    transitionTime = _ref.transitionTime,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    htmlProps = _ref.htmlProps;
  var backgroundColor = isDark || darkMode ? 'bg-gray-dark' : 'bg-gray-main';
  var barColor = isDark || darkMode ? 'bg-primary-light' : 'bg-primary-main';
  if (backgroundClassName || backgroundColorProp) {
    backgroundColor = backgroundColorProp ? "bg-".concat(backgroundColorProp) : backgroundClassName;
  }
  if (barClassName || barColorProp) {
    barColor = barColorProp ? "bg-".concat(barColorProp) : barClassName;
  }
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    className: cn('relative', size === 'm' ? 'h-8' : 'h-4', backgroundColor, {
      'w-full': full
    }, className),
    role: "progressbar",
    "aria-valuenow": progress,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    style: _objectSpread(_objectSpread({}, style), {}, {
      transition: transition('background-color')
    })
  }, htmlProps), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: "h-full ".concat(barColor),
      style: {
        width: progress && progress > 100 ? '100%' : "".concat(progress || 0, "%"),
        transition: transition(['width', 'background-color'], transitionTime)
      }
    })
  }));
};
export default ProgressBar;